import { Task, TaskNames, TaskState } from '../modules/jobs/domain/task'

export const toSnakeCaseObject = (obj: Record<string, any>): Record<string, any> => {
  const snakeCaseObj: Record<string, any> = {}

  Object.keys(obj).forEach((key) => {
    const snakeCaseKey = key.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`)
    snakeCaseObj[snakeCaseKey] = obj[key]
  })

  return snakeCaseObj
}

export const removeQueryParamsEmpty = (obj) => {
  Object.keys(obj).forEach((k) => {
    if (obj[k] === '' || obj[k] === undefined || obj[k] === null) {
      delete obj[k]
    }
  })
}

export const removeNullishQueryParams = (obj) => {
  Object.keys(obj).forEach((k) => {
    if (obj[k] === undefined || obj[k] === null) {
      delete obj[k]
    }
  })
}

export const capitalizeText = (str: string) => {
  if (!str) return ''
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
}

export const filterTaskWithoutMultistopCanceled = (tasks: Task[]) => {
  if (tasks?.length) {
    return tasks.filter(({ name, status }) => !(name === TaskNames.PICKING_MULTI_STOP && status === TaskState.CANCELED))
  }
  return tasks
}

export const getErrorMessage = (error: unknown): string => {
  if (error instanceof Error) {
    return error.message
  }

  if (typeof error === 'string') {
    return error
  }

  if (error && typeof error === 'object') {
    return JSON.stringify(error)
  }

  return String(error)
}
